(function() {
    import("angular").then(angular => {
        var app = angular.module("tapAssetManager");

        app.factory("assetStorage", [
            "storageFactory",
            function(storageFactory) {
                var assetStorage = storageFactory.getInstance("assetStorage");

                return assetStorage;
            },
        ]);
    });
})();
